import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

const rootElement = document.getElementById("container");
ReactDOM.render(<App />, rootElement);
